/* eslint-disable no-restricted-properties */
/* eslint-disable no-restricted-globals */
/* eslint-disable array-callback-return */
/* eslint-disable brace-style */
/* eslint-disable no-console */
/* eslint-disable no-useless-escape */
import { LANGUAGES_CODE, FR_TAX_TYPE_LABELS } from "./constants"

const toFixed = (num, fixed, returnInt = false) => {
  fixed = fixed || 0
  const multiplier = 10**fixed
  num = typeof num === 'string' ? parseFloat(num) : num
  if (num === 0) {
    return '0.00'
  }
  if (!isNaN(num)) {
    num = (Math.round(num * multiplier) / multiplier).toFixed(fixed)
    return returnInt ? Math.round(num * 100) : num
  }
  return ''
}

const getPromoDiscountDollars = (promoDiscountCents) => {
  // Convert promo discount to dollars
  const promoDiscountDollars = promoDiscountCents / 100
  // Get absolute value of promo discount
  const absolutePromoDiscount = Math.abs(promoDiscountDollars)
  // Format promo discount to two decimal places
  const formattedPromoDiscount = parseFloat(absolutePromoDiscount.toFixed(2))

  return formattedPromoDiscount === 0 ? 0 : -1 * formattedPromoDiscount
}

const isNullOrEmpty = (value) => {
  if (value === '' || value === null || value === undefined) {
    return true
  }
  return false
}

const getTaxResponse = (responseTax) => {
  let val = 0
  responseTax?.data?.map(({ chargeable }) => {
    val += chargeable
  })
  return `${toFixed(val, 2)}`
}

const getTaxDetails = (responseTax, selectedLanguage) => {
  return responseTax?.data?.map(({ tax, value, chargeable }) => {
    const label = selectedLanguage === LANGUAGES_CODE.EN ? tax : FR_TAX_TYPE_LABELS[tax?.toUpperCase()]
    return {
      label: `${label} (${toFixed(value * 100, 2)}%)`,
      value: `${toFixed(chargeable, 2)}`
    }
  })
}

const getTaxProvince = (responseTax) => {
  return responseTax?.data?.map(({ province }) => {
    return province
  })
}

const getTaxProvinceId = (provinces, provinceShortName) => {
   const { value } = provinces.find(
      (prov) => prov.shortName?.toLowerCase() === provinceShortName?.toLowerCase()
    )
    return value
}

const containsProvince = (provinces, province) => {
  return provinces?.some((prov) => prov?.toLowerCase() === province?.toLowerCase())
}


// Generate the cookie in the same format as uCare.
const setCookie = (key, value, expiry, domain, encode = true) => {
    const encodedValue = encode
      ? btoa(encodeURIComponent(value))
      : encodeURIComponent(value)
    document.cookie = `${key}=${encodedValue};max-age=${expiry};path=/;domain=${domain}`
}

const getCookie = (name, decode = true) => {
  const cookieString = document.cookie
  const cookies = cookieString.split('; ').reduce((acc, cookie) => {
    const [cookieName, ...cookieValue] = cookie.split('=')
    acc[cookieName] = cookieValue.join('=')
    return acc
  }, {})
  
  if (!cookies[name]) {
    return cookies[name]
  }
  
  if (decode) {
    try {
      // Try base64 decode first
      return decodeURIComponent(atob(cookies[name]))
    } catch (e) {
      // If base64 decode fails, just decode URI component
      try {
        return decodeURIComponent(cookies[name])
      } catch (e2) {
        // If all decoding fails, return raw value
        return cookies[name]
      }
    }
  } else {
    try {
      return decodeURIComponent(cookies[name])
    } catch (e) {
      return cookies[name]
    }
  }
}

const getOptanonConsentMap = () => {
  const optanonCookie = getCookie('OptanonConsent', false)
  if (!optanonCookie) return null
  const optanonCookieMap = optanonCookie.split('&').reduce((acc, cookie) => {
    const [cookieName, ...cookieValue] = cookie.split('=')
    acc[cookieName] = cookieValue.join('=')
    return acc
  }, {})
  return optanonCookieMap
}

const getOptanonConsentGroupMap = () => {
  const optanonCookieMap = getOptanonConsentMap()
  const optanonCookieGroup = optanonCookieMap?.groups
  if (!optanonCookieGroup) return null
  const optanonCookieGroupMap = optanonCookieGroup
    .split(',')
    .reduce((acc, value) => {
      const [groupKey, groupValue] = value.split(':')
      acc[groupKey] = groupValue
      return acc
    }, {})
  return optanonCookieGroupMap
}

const isOptanonConsentLatest = (cookieAcknowledgeLastUpdate) => {
  const { datestamp } = getOptanonConsentMap() || {}
  const lastUpdate = getCookie(cookieAcknowledgeLastUpdate, false)
  if (!datestamp) return false
  if (!lastUpdate) return true

  // datestamp : Koodo, lastUpdate: Kpre
  return new Date(datestamp) > new Date(lastUpdate)
}

const convertOptanonMapToConsentObject = (optanonCookieMap, OptanonGroupCodeMap) =>
  Object.entries(OptanonGroupCodeMap).reduce((acc, [group, ids]) => {
    ids.forEach((id) => {
      acc[id] = optanonCookieMap[group] === '1' ? 'granted' : 'denied'
    })
    return acc
  }, {})

const compareConsents = (consent1, consent2) => {
  const consent1String =
    typeof consent1 === 'string' ? consent1 : JSON.stringify(consent1)
  const consent2String =
    typeof consent2 === 'string' ? consent2 : JSON.stringify(consent2)
  return consent1String === consent2String
}

const getPromoNames = (res) => {
  if(res){
    const promoNames = res?.flatMap(item => item?.bundles?.map(b => b.name) || [])?.filter(Boolean) // removes undefined/null
      ?.join(", ");

    return promoNames
  }
  return 'NA'
}

const doesPageMatch = (currentPage, pageRules = []) => {
  return pageRules.some(rule => {
    // Handle special cases like plans
    if (rule === "plans") {
      return currentPage?.includes("/plans");
    }

    // Default: treat as "endsWith" (exact last segment match)
    return currentPage?.endsWith(rule);
  });
}

const encryptAtuPromoCode = (data, encrypt, passphrase) => {
  if (!data?.pageContent) return data;

  data.pageContent.forEach(page => {
    if (page.id !== 'paymentPageConsumer' && page.id !== 'paymentPageDealer') return;
    let encryptedValue = null;

    // Find and encrypt once from the EN field
    const enField = page.en?.shortTextFields?.find(f => f.slug === 'atuPromoCode');
    if (enField && enField?.value) {
      encryptedValue = encrypt(enField.value, passphrase);
      enField.value = encryptedValue;
    }

    // Apply the same encrypted value to the FR field
    if (encryptedValue && page.fr?.shortTextFields) {
      const frField = page.fr.shortTextFields.find(f => f.slug === 'atuPromoCode');
      if (frField) {
        frField.value = encryptedValue;
      }
    }
  });

  return data;
}

const decryptPromoCodes = (promoCodeString, decrypt, passphrase) => {
  if (!promoCodeString) return { result: '', decryptedPromo: null, encryptedPromo: null }

  let decryptedPromo = null
  let encryptedPromo = null

  const result = promoCodeString
    .split(';')
    .map(code => {
      const trimmed = code.trim();
      const isEncrypted = /[:=\/+]/.test(trimmed);

      if (isEncrypted) {
        try {
          const decrypted = decrypt(trimmed, passphrase);
          // store first decrypted + original encrypted pair
          if (!decryptedPromo) {
            decryptedPromo = decrypted
            encryptedPromo = trimmed
          }
          return decrypted
        } catch (err) {
          console.error('Decryption failed for:', trimmed, err);
          return trimmed;
        }
      }

      return trimmed;
    })
    .join(';');

  return { result, decryptedPromo, encryptedPromo }
}

/**
 * Escapes every RegExp metacharacter in `value` so it can be embedded in a
 * pattern as a literal.
 *
 * Escaping only the dots (`value.replace(/\./g, '\\.')`) is the tempting
 * shortcut and is wrong: it leaves `\ * + ? ^ $ { } ( ) | [ ]` live, so a
 * backslash in the input still opens an escape sequence in the result. Use this
 * for anything interpolated into `new RegExp()`, including values that look
 * safe today but are configurable — a Contentful-supplied email domain, say.
 */
const escapeRegExp = (value) => String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

export {
  escapeRegExp,
  toFixed, getPromoDiscountDollars, isNullOrEmpty, getTaxResponse, getTaxDetails, getTaxProvince, getTaxProvinceId, containsProvince, setCookie, getCookie, getOptanonConsentMap, getOptanonConsentGroupMap, isOptanonConsentLatest, convertOptanonMapToConsentObject, compareConsents, getPromoNames, doesPageMatch, encryptAtuPromoCode, decryptPromoCodes
}
